module.exports = __webpack_public_path__ + "static/img/watermark_bg.01d2dfd9.png";